<app-header [progress]="3" [title]="locale.currentTranslation.tripInformationHeader" data-testid="driver-age-header"></app-header>
<div class="base-content-container" data-testid="driver-age-container">
  <div class="headline3" data-testid="driver-age-title">{{ locale.currentTranslation.driverAge1 }}
  </div>
  <div style="display: flex; flex-direction: column; gap: 24px;" data-testid="age-form">
    <div class="radio-button-base" data-testid="age-input-container">
      <div style="width: 100%;">
        <app-text-input
          [type]="'number'"
          [(value)]="age"
          [placeholder]="locale.currentTranslation.driverAgeInputPlaceholder"
          [showError]="showError"
          [required]="true"
          data-testid="input-age"
          [attr.aria-label]="locale.currentTranslation.driverAgeInputPlaceholder"
        ></app-text-input>
      </div>
    </div>
  </div>
  @if (showError) {
    <div class="caption1 error-text" data-testid="validation-error" role="alert">
      {{ locale.currentTranslation.errorMessageUserInputNotChosen }}
    </div>
  }
</div>
<div class="main-button-spacing">
  <button class="main-button" (click)="nextClicked()" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
</div>
<app-footer data-testid="driver-age-footer"></app-footer>
